var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8965 13.6943C17.8848 11.6963 18.79 10.1904 20.6182 9.08008C19.5957 7.61524 18.0488 6.80957 16.0098 6.6543C14.0791 6.50195 11.9668 7.7793 11.1934 7.7793C10.376 7.7793 8.50684 6.70703 7.03613 6.70703C4.00098 6.75391 0.775391 9.12695 0.775391 13.9551C0.775391 15.3818 1.03613 16.8555 1.55762 18.373C2.25488 20.3711 4.76855 25.2666 7.39062 25.1875C8.76172 25.1553 9.73144 24.2148 11.5156 24.2148C13.2471 24.2148 14.1436 25.1875 15.6729 25.1875C18.3184 25.1494 20.5918 20.6992 21.2539 18.6953C17.7061 17.0225 17.8965 13.7969 17.8965 13.6943ZM14.8174 4.75879C16.3027 2.99512 16.168 1.38965 16.124 0.8125C14.8115 0.888672 13.2939 1.70605 12.4297 2.71094C11.4775 3.78906 10.918 5.12207 11.0381 6.625C12.4561 6.7334 13.751 6.00391 14.8174 4.75879Z",
    fill: "#2D3436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.f3c68cc2ce2b038b4c9417d384cda651.svg";
export { ForwardRef as ReactComponent };